import { StandardEvents } from '@shopify/events';

// Follow the same resolved cart event as Horizon's native cart-icon component.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart }) => {
    const count = cart?.totalQuantity;
    if (!Number.isInteger(count) || count < 0) return;
    const text = `${count} ${count === 1 ? 'artículo' : 'artículos'}`;
    document.querySelectorAll('[data-db-cart-label]').forEach((label) => { label.textContent = text; });
    document.querySelectorAll('[data-db-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[aria-controls="cart-drawer"]').forEach((trigger) => {
      trigger.setAttribute('aria-label', `Carrito de compra, ${text}`);
    });
  }).catch(() => { /* The native cart displays any request error. */ });
});
